/* Pause CSS marquee animations while they are off screen or the tab is hidden.

   Elements marked data-pause-offscreen either run an infinite CSS animation themselves
   (marquee-carousel, marquee-ticker) or contain several copies that must move in lockstep
   (Ticker-section, Celebs: the attribute sits on the .wrap-for container). Off screen the
   animation still costs style and paint work on every frame, which matters on mid-range
   Android. An IntersectionObserver sets animation-play-state: paused inline on the element
   and on every animated descendant while the container is out of view (plus a 100px
   margin), and removes the inline property when it is back, so a section's own :hover
   pause rule keeps working and the copies never drift apart. Without IntersectionObserver
   nothing changes, the animation runs as before. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var visible = new Set();

  function animatedTargets(el) {
    if (!el._pauseTargets) {
      var list = [el].concat(Array.prototype.slice.call(el.querySelectorAll('*')));
      el._pauseTargets = list.filter(function (n) { return getComputedStyle(n).animationName !== 'none'; });
    }
    return el._pauseTargets;
  }

  function setPaused(el, paused) {
    animatedTargets(el).forEach(function (n) {
      if (paused) n.style.animationPlayState = 'paused';
      else n.style.removeProperty('animation-play-state');
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { visible.add(e.target); if (!document.hidden) setPaused(e.target, false); }
      else { visible.delete(e.target); setPaused(e.target, true); }
    });
  }, { rootMargin: '100px 0px' });

  function bind(root) {
    (root || document).querySelectorAll('[data-pause-offscreen]:not([data-pause-bound])').forEach(function (el) {
      el.setAttribute('data-pause-bound', '');
      setPaused(el, true);
      io.observe(el);
    });
  }

  document.addEventListener('visibilitychange', function () {
    visible.forEach(function (el) { setPaused(el, document.hidden); });
  });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
})();
